import { render, staticRenderFns } from "./Supporter.vue?vue&type=template&id=095f659a&scoped=true&"
import script from "./Supporter.vue?vue&type=script&lang=ts&"
export * from "./Supporter.vue?vue&type=script&lang=ts&"
import style0 from "./Supporter.vue?vue&type=style&index=0&id=095f659a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f659a",
  null
  
)

export default component.exports